import script from "./PlaceholderDoctorBlockedModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlaceholderDoctorBlockedModal.vue?vue&type=script&setup=true&lang=ts"

import "./PlaceholderDoctorBlockedModal.vue?vue&type=style&index=0&id=63af18ee&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63af18ee"]])

export default __exports__